export enum Format {
    ONLINE = 'online',
    OFFLINE = 'offline',
    HYBRID = 'hybrid',
}

